import type { RuoloDTO } from '@/models/dto/utente/ruolo-dto'
import { mapToRole, mapToRuoliDTO } from '@/models/mappers/user/role-mapper'
import type { Role } from '@/models/types/user/role'
import { makeRequest, type MakeRequestOptions } from './make-request'

type RoleCrudType = () => {
    getOne: (id: string, options?: MakeRequestOptions) => Promise<Role>
    getMany: (options?: MakeRequestOptions) => Promise<Role[]>
    post: (role: Omit<Role, 'id'>, options?: MakeRequestOptions) => Promise<Role>
    put: (role: Role, options?: MakeRequestOptions) => Promise<Role>
    delete: (id: string, options?: MakeRequestOptions) => Promise<void>
}

const ROLE_URL =
    typeof window === 'undefined'
        ? `${process.env.API_URL}/api/v1/Ruoli`
        : `${location.origin}${process.env.NEXT_PUBLIC_BASEPATH}/api/v1/Ruoli`
const ROLE_TAG = 'role'

const roleCRUD: RoleCrudType = () => ({
    getOne: async (id, options) => {
        const url = new URL(`${ROLE_URL}/${id.toString()}`)
        const ruoliDTO = await makeRequest<RuoloDTO>(url, { method: 'GET', next: { tags: [ROLE_TAG] }, ...options })
        const role = mapToRole(ruoliDTO) as Role
        return role
    },
    getMany: async (options) => {
        const url = new URL(ROLE_URL)
        const ruoliDTO = await makeRequest<RuoloDTO[]>(url, { method: 'GET', next: { tags: [ROLE_TAG] }, ...options })
        const roles = ruoliDTO.map((ruolo) => mapToRole(ruolo)) as Role[]
        return roles
    },
    post: async (role, options) => {
        const ruoliDTO = mapToRuoliDTO(role)
        const url = new URL(ROLE_URL)
        const ruoliDTOResponse = await makeRequest<RuoloDTO>(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(ruoliDTO),
            ...options,
        })
        const roleResult = mapToRole(ruoliDTOResponse) as Role
        return roleResult
    },
    put: async (role, options) => {
        const ruoliDTO = mapToRuoliDTO(role)
        const url = new URL(ROLE_URL)
        const ruoliDTOResponse = await makeRequest<RuoloDTO>(url, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(ruoliDTO),
            ...options,
        })
        const roleResult = mapToRole(ruoliDTOResponse) as Role
        return roleResult
    },
    delete: async (id, options) => {
        const url = new URL(`${ROLE_URL}/${id.toString()}`)
        await makeRequest(url, { method: 'DELETE', ...options })
    },
})

export { roleCRUD, type RoleCrudType }
